module.exports = __webpack_public_path__ + "static/img/1.45bd214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/1.jpg
// module id = Hr6n
// module chunks = 0